import dev from './env.dev.js';
import prod from './env.prod.js';


let env = {};
if (process.env.NODE_ENV == 'development') {
    env = dev;
}
else if (process.env.NODE_ENV == 'production') {
    env = prod;
}
const key = env.key || '';
const domain = env.domain || '';
const hostUrl = env.hostUrl || "";
const wyy = env.wyy || {};
const dingWebAppId = env.dingWebAppId || "";
const apiDebug = env.apiDebug || false;
const sysDebug = env.sysDebug || false;
const websocket = env.websocket || {};



export {
    domain,
    hostUrl,
    wyy,
    dingWebAppId,
    apiDebug,
    sysDebug,
    key,
    websocket,
}


// WEBPACK FOOTER //
// ./src/env/index.js